import UserMapSkill from './UserMapSkill';

export { UserMapSkill };



// WEBPACK FOOTER //
// src/modules/screens/settings/UserMapSkill/components/index.js